import SignUp from "./sign-up"

export default SignUp
